var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',{staticClass:"w-loader-overlay"},[_vm._v("globale op loading...")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }